import cookie from 'js-cookie'
import VueI18n from 'vue-i18n'
import get from 'lodash/get'
import moment from 'moment';
import { dynamicTranslation4Rebranding } from '@zoom/billing-rebranding';
import { I18nReady } from '@/utils/ready';
import i18nEnUS from '../../i18n/en-US.json'
import { pageConfig } from '@/common/service/page-config';

window.ZBilling = window.ZBilling || {}
let i18nMessage = null;

// locale code to i18n file local code
const LocaleMap = {
  "gov-EN": "en-US",
  "en-US": "en-US",
  "es-ES": "es-ES",
  "de-DE": "de-DE",
  "zh-CN": "zh-CN",
  "zh-TW": "zh-TW",
  "fr-FR": "fr-FR",
  "pt-PT": "pt-PT",
  "jp-JP": "ja-JP",
  "ja-JP": "ja-JP",
  "ru-RU": "ru-RU",
  "ko-KO": "ko-KR",
  "ko-KR": "ko-KR",
  "it-IT": "it-IT",
  "vi-VN": "vi-VT",
  "nl-NL": "nl-NL",
  "tr-TR": "tr-TR",
  "id-ID": "id-ID",
  "pl-PL": "pl-PL",
  "sv-SE": "sv-SE",
}

export const momentI18nMap = {
  "gov-EN": "en",
  "en-US": "en",
  "es-ES": "es",
  "de-DE": "de",
  "zh-CN": "zh-cn",
  "zh-TW": "zh-tw",
  "fr-FR": "fr",
  "pt-PT": "pt",
  "jp-JP": "ja",
  "ru-RU": "ru",
  "ko-KO": "ko",
  "it-IT": "it",
  "vi-VN": "vi",
  "nl-NL": "nl",
  "tr-TR": "tr",
  "id-ID": "id",
  "pl-PL": "pl",
  "sv-SE": "sv",
}

const hreflangJson = [
  {"id":"en", "code":"en-US"},
  {"id":"es", "code":"es-ES"},
  {"id":"de", "code":"de-DE"},
  {"id":"zh-cn", "code":"zh-CN"},
  {"id":"zh-tw", "code":"zh-TW"},
  {"id":"fr", "code":"fr-FR"},
  {"id":"pt", "code":"pt-PT"},
  {"id":"ja", "code":"jp-JP"},
  {"id":"ru", "code":"ru-RU"},
  {"id":"ko", "code":"ko-KO"},
  {"id":"it", "code":"it-IT"},
  {"id":"vi", "code":"vi-VN"},
  {"id":"pl", "code":"pl-PL"},
  {"id":"tr", "code":"tr-TR"},
  {"id":"id", "code":"id-ID"},
  {"id":"nl", "code":"nl-NL"},
  {"id":"sv", "code":"sv-SE"}
];
function setMomentI18n() {
  const momentLocale = momentI18nMap[getLocale()] || "en";

  return moment.locale(momentLocale);
}

function getLocale() {
  // window._zm_lang is set by client side, reset _zm_lang in cookie if in client modal checkout
  const zmLang = window._zm_lang;
  if (zmLang && zmLang !== cookie.get('_zm_lang')) {
    let cookieDomain = document.body.getAttribute('data-cd');
    if (!cookieDomain) {
      cookieDomain = '.zoom.us';
    }
    cookie.set('_zm_lang', zmLang, { expires: 365, path: '/', domain: cookieDomain, secure: true });
  }

  const cookieLang = cookie.get('_zm_lang');
  const isGov = window.ZBilling.isGov;
  if (isGov) {
    return 'gov-EN';
  }
  return cookieLang || 'en-US';
}

export const locale = getLocale();

export function getHreflang() {
  let hreflang = 'en';

  hreflangJson.forEach(function (jsonEle) {
    if (jsonEle.code === locale) {
      hreflang = jsonEle.id;
    }
  });

  return hreflang;
}

window.Vue.use(VueI18n)

function isNative(Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

const hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys)

function ensureCtor(comp) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default
  }
  return comp
}

export function getCurrentI18n() {
  return i18nMessage
}

export let _i18n = null


export function originalTranslation (i18nKey, params = []) {
  if (_i18n) {
    return _i18n.t(i18nKey, params);
  }
  throw new Error('i18n not ready.');
}

export const translation = dynamicTranslation4Rebranding(
  originalTranslation,
  { isZoomWorkplaceRebranding: pageConfig?.isZoomWorkplaceRebranding, sessionToWebinarPlusRename: pageConfig?.sessionToWebinarPlusRename },
);

/**
 * translate to English
 * @param {string} key
 * @param {array} args
 * @returns {string}
 */
export function translateToEn(key, args = []) {
  let result = get(i18nEnUS, key) || get(i18nEnUS, [key], key)
  if (typeof result !== 'string') {
    console.error('Invalid key, requires String type')
    return ''
  }
  Object.entries(args).forEach(([k, v]) => {
    result = result.replace(new RegExp(`\\{${k}\\}`, 'g'), v)
  })
  return dynamicTranslation4Rebranding(() => result, { isZoomWorkplaceRebranding: pageConfig?.isZoomWorkplaceRebranding, sessionToWebinarPlusRename: pageConfig?.sessionToWebinarPlusRename })()
}

export default function resolveI18n() {
  const i18nLocale = LocaleMap[locale];
  setMomentI18n();
  return import(/* webpackChunkName: "[request]" */`../../i18n/${i18nLocale}.json`).then((res) => {
    i18nMessage = ensureCtor(res)
    _i18n = new VueI18n({
      locale: i18nLocale,
      fallbackLocale: 'en-US',
      messages: { 'en-US': i18nEnUS, [i18nLocale]: i18nMessage },
    });
    I18nReady.solved(_i18n);
    return _i18n;
  })
}
